/**
 * Editor.js types block data as `any`. Paragraph blocks keep their HTML in `data.text`,
 * so read that field without trusting the shape. Accepts partial blocks from form state too.
 */
export function getBlockText(block: { data?: unknown } | undefined): string | undefined {
  const data = block?.data;

  if (typeof data !== 'object' || data === null || !('text' in data)) {
    return undefined;
  }

  return typeof data.text === 'string' ? data.text : undefined;
}
